"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightOverride = void 0;
class LightOverride {
    constructor() {
        this.id = null;
        this.type = "UNSPECIFIED" /* UNSPECIFIED */;
        this.position = { x: 0, y: 0, z: 0 };
        this.rotation = { x: 0, y: 0, z: 0 };
        this.scale = { x: 1, y: 1, z: 1 };
        this.color = "#000000";
        this.intensity = null;
        this.distance = null;
        this.angle = null;
        this.penumbra = null;
        this.decay = null;
    }
    ;
    ;
}
exports.LightOverride = LightOverride;
